import {
  ArrowType,
  IMPLICIT_REFTYPE_ID,
  LineType,
  type APIModelAttributes,
  type APIReferenceType,
} from '@ardoq/api-types';

export type DefaultReferenceTypeNames = {
  asynchronous: string;
  synchronous: string;
  implicit: string;
  fireAndForget: string;
  dataFlow: string;
};

export const DEFAULT_REFERENCE_TYPE_NAMES: DefaultReferenceTypeNames = {
  asynchronous: 'Asynchronous',
  synchronous: 'Synchronous',
  implicit: 'Implicit',
  fireAndForget: 'Fire and forget',
  dataFlow: 'Data flow',
};

export const getDefaultReferenceTypes = (
  names: DefaultReferenceTypeNames = DEFAULT_REFERENCE_TYPE_NAMES
): Record<number, APIReferenceType> => ({
  0: {
    name: names.asynchronous,
    id: 0,
    index: 0,
    line: LineType.DOTTED,
    color: '#00f',
    lineBeginning: ArrowType.NONE,
    lineEnding: ArrowType.BOTTOM,
    returnsValue: true,
    svgStyle: null,
  },
  1: {
    name: names.synchronous,
    id: 1,
    index: 1,
    line: LineType.SOLID,
    color: '#000',
    lineBeginning: ArrowType.NONE,
    lineEnding: ArrowType.BOTH,
    returnsValue: true,
    svgStyle: null,
  },
  [IMPLICIT_REFTYPE_ID]: {
    name: names.implicit,
    id: IMPLICIT_REFTYPE_ID,
    index: IMPLICIT_REFTYPE_ID,
    line: LineType.DASHED,
    color: '#f00',
    lineBeginning: ArrowType.NONE,
    lineEnding: ArrowType.BOTH_FILLED,
    returnsValue: false,
    svgStyle: null,
  },
  3: {
    name: names.fireAndForget,
    id: 3,
    index: 3,
    line: LineType.DOTTED,
    color: '#ffa500',
    lineBeginning: ArrowType.NONE,
    lineEnding: ArrowType.BOTH,
    returnsValue: false,
    svgStyle: null,
  },
  4: {
    name: names.dataFlow,
    id: 4,
    index: 4,
    line: LineType.SOLID,
    color: '#808080',
    lineBeginning: ArrowType.NONE,
    lineEnding: ArrowType.CIRCLE,
    returnsValue: false,
    svgStyle: null,
  },
});

export const DEFAULT_REFERENCE_TYPES: Record<number, APIReferenceType> =
  getDefaultReferenceTypes();

export const getReferenceTypesWithDefaults = (
  model: APIModelAttributes
): APIReferenceType[] => {
  const referenceTypes = model.referenceTypes;
  if (!referenceTypes) {
    return Object.values(DEFAULT_REFERENCE_TYPES);
  }
  const withImplicit = referenceTypes[IMPLICIT_REFTYPE_ID]
    ? referenceTypes
    : {
        ...referenceTypes,
        [IMPLICIT_REFTYPE_ID]: DEFAULT_REFERENCE_TYPES[IMPLICIT_REFTYPE_ID],
      };
  return Object.values(withImplicit).filter(v => v !== undefined && v !== null);
};
